const NO_ATOM_INIT = 'no atom init';

export const getIsJotaiNoAtomInitError = (error: unknown): boolean =>
  error instanceof Error && error.message === NO_ATOM_INIT;
